import { defineMessages } from 'react-intl';
import { CREDIT_CARD_FIELDS, CREDIT_CARD_PROVIDERS } from './constants';

const { CARD_NAME, CARD_PROVIDER, CARD_NUMBER, CVV, CARD_EXPIRATION_YEAR, CARD_EXPIRATION_MONTH } = CREDIT_CARD_FIELDS;

export const messages = defineMessages({
  cardExpirationLabel: {
    defaultMessage: 'Card Expiration',
    id: '8Qun/y',
    description: 'Credit card info card expiration label',
  },
  monthDropdownEntryDefault: {
    defaultMessage: 'Select Month',
    id: 'PJyg5m',
    description: 'Month dropdown entry default',
  },
  monthDropdownEntry: {
    defaultMessage: '{monthDate, date, ::MM} - {monthDate, date, ::MMMM}',
    id: 'QyLTnR',
    description: 'Month dropdown entry',
  },
  providerDropdownEntryDefault: {
    defaultMessage: 'Select Provider',
    id: 'KpO4IA',
    description: 'Provider dropdown entry default',
  },
  fieldRequired: {
    defaultMessage: 'Required',
    id: 'xgbzdc',
    description: 'default message for required field',
  },
  invalidCreditCard: {
    defaultMessage: 'Invalid Card Number',
    id: 'V4zlI7',
    description: 'Error message for credit card number formatting',
  },
  invalidYearLength: {
    defaultMessage: 'YYYY',
    id: '03q8yS',
    description: 'Invalid year length',
  },
  inValidCVV: {
    defaultMessage: '3 or 4 digits',
    description: 'Invalid CVV code for credit card',
    id: 'fdhBtQ',
  },
  expiredCard: {
    defaultMessage: 'Credit Card is Expired',
    description: 'Expired credit card month or year',
    id: 'tBrHzh',
  },
});

export const creditCardFieldLabels = defineMessages({
  [CARD_NAME]: {
    description: 'Label for CARD_NAME',
    defaultMessage: 'Name on Card',
    id: '0zD+y4',
  },
  [CARD_PROVIDER]: {
    description: 'Label for CARD_PROVIDER',
    defaultMessage: 'Provider',
    id: '2qUh5r',
  },
  [CARD_NUMBER]: {
    description: 'Label for CARD_NUMBER',
    defaultMessage: 'Credit Card Number',
    id: '7PVSb7',
  },
  cardExpiration: {
    description: 'Label for CARD_EXPIRATION_MONTH',
    defaultMessage: 'Card Expiration',
    id: 'ij5sPV',
  },
  [CVV]: {
    description: 'Label for CVV',
    defaultMessage: 'CVV',
    id: 'THrQaN',
  },
});

export const creditCardPlaceholders = defineMessages({
  [CARD_EXPIRATION_YEAR]: {
    description: 'Placeholder for credit card year',
    defaultMessage: 'YYYY',
    id: 'np8vTI',
  },
});

const { AMERICAN_EXPRESS, VISA, DISCOVER, MASTERCARD, OTHER } = CREDIT_CARD_PROVIDERS;

export const cardProviderMessages = defineMessages({
  [AMERICAN_EXPRESS]: {
    description: 'Default label for AMERICAN_EXPRESS',
    defaultMessage: 'American Express',
    id: 'l2F3d+',
  },
  [VISA]: {
    description: 'Default label for VISA',
    defaultMessage: 'Visa',
    id: 'KfFlwv',
  },
  [DISCOVER]: {
    description: 'Default label for DISCOVER',
    defaultMessage: 'Discover',
    id: 'gaoAIi',
  },
  [MASTERCARD]: {
    description: 'Default label for MASTERCARD',
    defaultMessage: 'Mastercard',
    id: '2lDLR6',
  },
  [OTHER]: {
    description: 'Default label for OTHER',
    defaultMessage: 'Other',
    id: 'dnHElp',
  },
});

export const validationErrorMessages = defineMessages({
  [CARD_NAME]: {
    description: 'Required validation error message for CARD_NAME',
    defaultMessage: 'Card Name is Required',
    id: 'kvj8Yl',
  },
  [CARD_PROVIDER]: {
    description: 'Required validation error message for CARD_PROVIDER',
    defaultMessage: 'Provider is Required',
    id: 'Ow60Mh',
  },
  [CARD_NUMBER]: {
    description: 'Required validation error message for CARD_NUMBER',
    defaultMessage: 'Card Number is Required',
    id: 'l2WYc1',
  },
  [CVV]: {
    description: 'Required validation error message for CVV',
    defaultMessage: 'Required',
    id: 'ClzXcR',
  },
  [CARD_EXPIRATION_YEAR]: {
    description: 'Required validation error message for CARD_EXPIRATION_YEAR',
    defaultMessage: 'Req.',
    id: 'y79nDM',
  },
  [CARD_EXPIRATION_MONTH]: {
    description: 'Required validation error message for CARD_EXPIRATION_MONTH',
    defaultMessage: 'Card Month Required',
    id: 'WvC2Vv',
  },
});
